/*
 * Check the file /themes/act_health_public_website/js/firebase-messaging-sw.js
 * which contains the actual service worker for messaging
 */

/* global firebase, fetch */

'use strict';

// Constructor
var PushNotification = function () {
    if (typeof Promise !== "undefined" && Promise.toString().indexOf("[native code]") !== -1) {


// Initialize Firebase
        var config = {
            apiKey: "AIzaSyBxi0jwaUtZqvOQpb64GiO7wPQXxJeFa1E",
            authDomain: "notes-pushies.firebaseapp.com",
            databaseURL: "https://notes-pushies.firebaseio.com",
            projectId: "notes-pushies",
            storageBucket: "notes-pushies.appspot.com",
            messagingSenderId: "430795572684"
        };

        firebase.initializeApp(config);

        var messaging = firebase.messaging();

        var _token = void 0;

// Service worker file is on different path in drupal structure
        navigator.serviceWorker.register('/themes/act_health_public_website/js/firebase-messaging-sw.js').then(function (registration) {
            messaging.useServiceWorker(registration);

            // Get permission to subscribe to push notification
            messaging.requestPermission().then(function () {
                console.log('Have permission');
                return messaging.getToken();
            }).then(function (token) {
                _token = token;
                console.log(token);
            }).catch(function (err) {
                console.log('Error has occured');
                console.dir(err);
            });

            // When we get a notification
            messaging.onMessage(function (payload) {
                console.log('onMessage: ', payload);
            });

            // Register to topic ------ This need to be running on the server
            fetch('https://iid.googleapis.com/iid/v1/' + _token + '/rel/topics/public-website', {
                method: 'POST',
                headers: new Headers({
                    'Content-type': 'application/json',
                    'Authorization': 'key=AIzaSyDp3fihvNuqYS5X-P3_SrmfbM-t6FeEiMw'
                })
            }).then(function (response) {
                if (response.status < 200 || response.status >= 400) {
                    throw 'Error subscribing to topic: ' + response.status + ' - ' + response.text();
                }
                console.log('Subscribed to /rel/topics/public-website"');
            }).catch(function (error) {
                console.error(error);
            });
        }).catch(function ($event) {
            console.log('Could not register service worker.', $event.message);
        });

    }
};

module.exports = PushNotification;
